import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import {
  ListingVideoTutorialDocument,
  ListingVideoTutorialNode,
  PaginaDocument,
  PaginaNode,
} from '@gql/graphql'
import VideoTutorialListing from '@components/organisms/VideoTutorialListing/VideoTutorialListing'

interface Props {
  pagina?: PaginaNode
  listing?: ListingVideoTutorialNode
}

const VideoTutorialCategoryDetail = ({ pagina, listing }: Props) => {
  return <VideoTutorialListing {...{ pagina, listing }} key={listing.categoria.pk} buttonUrl />
}

export const getStaticPaths = NextWrapper.getStaticPaths(
  async () => ({
    paths: [],
    fallback: 'blocking',
  }),
  '/idee-verdi/[slug]'
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'video-tutorial-category-detail', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const keys = ['p']
    const extractedParams = {}

    if (slug) {
      const paramsArray = [...slug]

      keys.forEach((key) => {
        const keyIndex = paramsArray.indexOf(key)
        if (keyIndex !== -1 && keyIndex < paramsArray.length - 1) {
          extractedParams[key] = paramsArray[keyIndex + 1]
          paramsArray.splice(keyIndex, 2)
        }
      })

      slug = paramsArray
    }

    const {
      data: { listingVideoTutorial },
    } = await client.query({
      query: ListingVideoTutorialDocument,
      variables: {
        slug: slug[0],
        params: extractedParams,
      },
      context: {
        headers,
      },
    })

    if (
      !listingVideoTutorial ||
      !listingVideoTutorial.categoria ||
      !listingVideoTutorial?.videos ||
      listingVideoTutorial?.videos?.length == 0
    ) {
      return {
        notFound: true,
      }
    }

    return {
      props: {
        pagina: {
          ...listingVideoTutorial.categoria.pagina,
          titolo: listingVideoTutorial.categoria.nome,
          seo: {
            ...listingVideoTutorial.categoria.pagina.seo,
            canonicalUrl: listingVideoTutorial.canonicalUrl,
          },
        },
        listing: listingVideoTutorial,
      },
      revalidate: 60 * 10,
    }
  },
  '/informazioni-utili/video-tutorial/c/[slug]'
)

export default VideoTutorialCategoryDetail
